import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { DataProvider } from "@/context/DataContext";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Profile from "@/pages/Profile";
import Dashboard from "@/pages/Dashboard";
import CreateEvent from "@/pages/CreateEvent";
import Calendar from "@/pages/Calendar";
import EventDashboard from "@/pages/EventDashboard";
import Tasks from "@/pages/Tasks";
import Budget from "@/pages/Budget";
import Agenda from "@/pages/Agenda";
import Branding from "@/pages/Branding";
import Invites from "@/pages/Invites";
import Statistics from "@/pages/Statistics";
import Carbon from "@/pages/Carbon";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import LandingEditor from "@/pages/LandingEditor";
import Devis from "@/pages/Devis";
import CheckinsDashboard from "@/pages/CheckinsDashboard";
import PublicLanding from "@/pages/PublicLanding";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  return (
    <DataProvider>
      <Layout />
    </DataProvider>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/p/:slug" element={<PublicLanding />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
      <Route path="/profile" element={<Protected><DataProvider><Profile /></DataProvider></Protected>} />
      <Route element={<Protected><Shell /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/create-event" element={<CreateEvent />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/events" element={<EventDashboard />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/budget" element={<Budget />} />
        <Route path="/devis" element={<Devis />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/invites" element={<Invites />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/checkins" element={<CheckinsDashboard />} />
        <Route path="/landing-editor" element={<LandingEditor />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/carbon" element={<Carbon />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
